
<template>
  <div class="mask">
    <div class="main_content">
      <img class="close" @click="$parent.cancelpay()"  src="static/images/close.png" />
      <div class="paytitle">
        <p class="payhead">Century Games</p>
      </div>
      <div id="dropin" ></div>
      <template v-if="showCardPay">
        <div class="or_con">Or</div>
        <div class="card_list">
          <span class="card_item"><img src="../images/mc.svg" alt=""></span>
          <span class="card_item"><img src="../images/visa.svg" alt=""></span>
        </div>
        <div id="card-form" class="card_container" >
          <div id="card-name-field-container" class="card_field_item"></div>
          <div id="card-number-field-container" class="card_field_item"></div>
          <div id="card-expiry-field-container" class="card_field_item"></div>
          <div id="card-cvv-field-container" class="card_field_item"></div>
        </div>
        <div :class="{card_btn: true, disabled: cardSubmitDisabled}" ref="cardBtn" type="button">Pay now with Card</div>
      </template>
      <div class="loadimg" v-if="payis">
        <img class="load" src="static/images/load.gif" />
      </div>
    </div>
  </div>
</template>

<script>
  import { loadScript } from "@paypal/paypal-js"
  import { getobj } from '@/api/index.js'
  export default {
    name: 'paypal',
    props: ['payinfo','mount','paypal_client_id', "advanceCardSupport", 'is_paypal_advance'],
    data() {
      return {
        payis: true,
        cg_request_id: '',
        provider_order_id: '',
        approve_url: '',
        client_key: '',
        showCardPay: this.advanceCardSupport,
        baseurl: process.env.API_BASEURL,
        cardSubmitDisabled: true
      }
    },
    mounted() {
      this.initPaypal();
    },
    methods:{
      async initPaypal() {
        this.$parent.payment_log.report('web_payment_sdkinit_start');
        await this.loadPaypalSdk()
        if (!window.paypal) return
        this.renderPayBtn()
        if (this.advanceCardSupport) {
          this.renderCardPay()
        }
        this.payis= false;
      },
      async loadPaypalSdk() {
        try {
          const params = {
            "client-id": this.paypal_client_id,
            currency: this.payinfo.currency
          }
          // 如果是新版paypal支付方式
          if (this.is_paypal_advance) {
            // 如果高级支付支持当前货币
            if (this.advanceCardSupport) {
              params.components = "buttons,card-fields"
            } else {
              params['disable-funding'] = 'card'
            }
          }

          await loadScript(params)
        } catch (error) {
          console.error("failed to load the PayPal JS SDK script", error);
          this.$parent.payment_log.report('web_payment_sdkinit_fail',{
            code: 2,
            msg: error
          })
          this.$rum.errorReport(error)
        }
      },
      // 普通支付
      renderPayBtn() {
        const vm = this
        paypal.Buttons({
          createOrder: this.createOrder,
          onApprove: this.onApprove,
          onCancel: this.onCancel,
          onError: this.onError,
          onInit: function (data, actions) {
            console.log('paypal ok')
            vm.$parent.payment_log.report('web_payment_sdkinit_success');
          },
        }).render('#dropin');
      },
      // 高级卡支付
      renderCardPay() {
        const cardField = window.paypal.CardFields({
          createOrder: this.createOrder,
          onApprove: this.onApprove,
          onCancel: this.onCancel,
          onError: this.onError,
          inputEvents: {
            onChange: (data) => {
              if (data.isFormValid) {
                this.cardSubmitDisabled = !data.isFormValid
              }
            }
          },
        });

        // Render each field after checking for eligibility
        if (cardField.isEligible()) {
          const nameField = cardField.NameField();
          nameField.render("#card-name-field-container");

          const numberField = cardField.NumberField();
          numberField.render("#card-number-field-container");

          const cvvField = cardField.CVVField();
          cvvField.render("#card-cvv-field-container");

          const expiryField = cardField.ExpiryField();
          expiryField.render("#card-expiry-field-container");

          this.$refs.cardBtn.addEventListener("click", () => {
            if (this.cardSubmitDisabled) return
            this.payis= true
            cardField.submit()
          });
        } else {
          this.showCardPay = false
        }
      },
      // 创建订单
      createOrder(data, actions) {
        const vm = this
        vm.$parent.payment_log.report('web_payment_getorder_start');
        const params = vm.payinfo;
        if (data.paymentSource) {
          params.payment_source = data.paymentSource
        }
        // Set up the transaction
        return fetch( vm.baseurl + '/paypal/paypal_order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(getobj(params))
        }).then(function(res) {
          return res.json();
        }).then(function(data) {
          if (data.code !== 1) {
            console.log('paypal order create failed', data);
            vm.$parent.failpay("Order failed！");

            vm.$parent.payment_log.report('web_payment_getorder_fail',{
                code:3,
                msg: data.msg?data.msg:'Order failed'
            })

            vm.$rum.report('pay_err', {
              paystyle: 'paypal',
              type: 'createOrder',
              response: data,
              prams: JSON.stringify(getobj(vm.payinfo))
            }, 3)
            return
          }
          return data.data;
        }).then(function(orderData) {
          //console.log(orderData)
          vm.cg_request_id = orderData.cg_request_id;
          vm.provider_order_id = orderData.provider_order_id;
          sessionStorage.setItem('provider_order_id',orderData.provider_order_id);
          vm.$parent.updateProviderOrderId(orderData.provider_order_id)
          vm.$parent.payment_log.set_properties({
            cg_request_id:vm.provider_order_id
          })
          vm.$parent.payment_log.report('web_payment_getorder_success');
          vm.$parent.payment_log.report('web_payment_userpay_start');

          vm.$rum.report('pay_sucess', {
            paystyle: 'paypal',
            type: 'createOrder',
            response: orderData,
            prams: JSON.stringify(getobj(vm.payinfo))
          }, 1)
          return orderData.order_id;
        }).catch((error) => {
          vm.$parent.failpay("Order failed！");
          vm.$rum.errorReport(error);

          vm.$parent.payment_log.report('web_payment_getorder_error',{
              code:2,
              msg: error
          })
        });
      },
      // 支付成功
      onApprove(data, actions) {
        const vm = this
        var obj = {
          "provider_order_id": vm.provider_order_id,
        };
        vm.$parent.payment_log.report('web_payment_userpay_success');
        vm.$parent.payment_log.report('web_payment_verification_start');
        // fetch
        return fetch(vm.baseurl + '/paypal/paypal_capture', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(getobj(obj))
        }).then(function(res) {
          return res.json();
        }).then(function(data) {
          //console.log(data)
          var orderData = data.data;
          vm.payis= false;
          if(data.code==1){
            vm.$parent.successpay(orderData);

            vm.$parent.payment_log.set_properties({
              transaction_id:orderData.transaction_id?orderData.transaction_id:''
            })
            vm.$parent.payment_log.report('web_payment_check_success');

            vm.$rum.report('pay_sucess', {
              paystyle: 'paypal',
              type: 'onApprove',
              response: data,
              prams: JSON.stringify(getobj(obj))
            }, 1)
          }else{
            var errorDetail = Array.isArray(orderData.error_details) && orderData.error_details[0];
            //console.log(errorDetail)
            if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
              return actions.restart();
            }else{
              vm.$parent.failpay(data)
            }

            vm.$parent.payment_log.report('web_payment_check_fail',{
                code:3,
                msg: data.msg ? data.msg: ''
            })

            vm.$rum.report('pay_err', {
              paystyle: 'paypal',
              type: 'onApprove',
              response: data,
              prams: JSON.stringify(getobj(obj))
            }, 3)
          }
          return;

        }).catch((error) => {
          console.error('capture failed', error);
          // try {
          //   window.opener.new_pay_child_notify('paypalOrderCapture failed');
          // } catch (e){}
          vm.payis= false;

          vm.$parent.failpay('Payment failure');
          vm.$parent.payment_log.report('web_payment_check_error',{
              code:2,
              msg:error
          });
          vm.$rum.errorReport(error)
          return;
        });
      },
      // 错误处理
      onError(err) {
        console.log('onError', err);
        this.payis= false;
        this.$parent.failpay('Payment failure');
        if(this.provider_order_id==''){
          this.$parent.payment_log.report('web_payment_sdkinit_fail',{
              code:2,
              msg:err
          })
        }else{
          this.$parent.payment_log.report('web_payment_userpay_fail',{
              code:2,
              msg:err
          })
        }

        this.$rum.errorReport(err)
        //throw Error(error);
      },
      // 取消支付回调
      onCancel(data) {
        this.payis= false;
        this.$parent.payment_log.report('web_payment_userpay_cancel')
      }
    },
  }
</script>

<style scoped>
.main_content{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  max-width: 750px;
  width: 90%;
  background-color: #FFFFFF;
  padding: 16px;
  box-sizing: border-box;
}
#dropin, .card_field_item{
  font-size: 0;
}
  .or_con{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909697;
    padding: 8px 0;
  }
  .or_con::before, .or_con::after{
    content: '';
    display: block;
    height: 1px;
    flex-grow: 1;
    background: #cbd2d6;
  }
  .or_con::before{
    margin-right: 10px;
  }
  .or_con::after{
    margin-left: 10px;
  }
  .card_container{
    height: 21rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .card_list{
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 8px;
  }
  .card_item{
    width: 24px;
    height: 16px;
    border-radius: 4px;
    border: 1px solid #e6e9eb;
    font-size: 0;
    margin-left: 8px;
    overflow: hidden;
  }
  .card_item img{
    width: 24px;
    height: 16px;
  }
  .card_btn{
    position: relative;
    height: 55px;
    border-radius: 4px;
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bolder;
    font-size: 16px;
    font-style: italic;
    cursor: pointer;
  }
  .card_btn.disabled::after{
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(255, 255, 255, .3);
  }
  .card_btn.disabled{
    cursor: not-allowed;
  }
  .loadmask{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    padding-top: 3.75rem;
    top: 0;
    left: 0;
  }
  .loadmask p{
    color: #FFFFFF;
    font-size: 0.875rem;
    text-align: center;
  }
  .paytitle p{
    font-size:1rem;
    line-height:1.875rem;
    margin-bottom: 0.625rem;
    text-align: center;
  }
  .payhead{
    font-family: "SemiBold";
  }
  .loadimg{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .close{
    position: absolute;
    top: -2.4rem;
    right: 0;
    width: 1.875rem;
    height: 1.875rem;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/paypal.vue